<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex"
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import Swal from "sweetalert2";
import axios from "axios";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Untaken Orders",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect,
  },
  data() {
    return {
      total_amount: 0,
      total_paid: 0,
      total_discount: 0,
      total_balance: 0,

      data: {
        saledetail_id: '',
        product_id: '',
        product_name: '',
        quantity: '',
        quantity_remaining: '',
        date: moment(new Date()).format("YYYY-MM-DD"),
      },
      orderdata: {
        id: '',
        date: moment(new Date()).format("YYYY-MM-DD"),
      },
      filterdata: {
        product: '',
        customer: '',
        branch_id: 0
      },

      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Untaken Orders",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Untaken Orders",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      ReturnedSales: [],
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "details",
          sortable: true,
          label: 'DETAILS',
        },
        {
          key: "customerobj.name",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "totalAmt",
          sortable: true,
          label: 'TOTAL',
        },
        {
          key: "totalPaid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "addedon",
          sortable: true,
          label: "DATE",
        },
        {
          key: "actions",
          sortable: true,
          label: "ACTIONS",
        }
      ],
      QtyError: ""
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("sales", ["UntakenOrders", "SaveStatus", "filterStatus"]),
    ...mapGetters("products", ["Products"]),
    ...mapGetters("setting", ["GeneralSettings", "ReceiptSettings"]),
    ...mapGetters("auth", ["business", "branch", "Branches", "branchid"]),
    ...mapGetters("customers", ["Customers"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.UntakenOrders ? this.UntakenOrders.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.UntakenOrders ? this.UntakenOrders.length : 1;
  },
  methods: {
    ...mapActions({
      FetchProducts: "products/fetchProducts",
      FetchUntakenOrders: "sales/fetchUntakenOrders",
      DispatchOrder: "sales/dispatchOrder",
      DispatchItem: "sales/dispatchItem",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      fetchReceiptSettings: "setting/fetchReceiptSettings",
      FetchCustomers: "customers/fetchCustomers",
    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    Receipt_print(Id) {
      if (this.ReceiptSettings.receipt_type == 1) {
        window.open(
          `https://${window.location.host}/receipts/salesreceipt.php?id=${btoa(Id)}`
        );
      } else if (this.ReceiptSettings.receipt_type == 2) {
        window.open(
          `https://${window.location.host}/receipts/salesreceiptv2.php?id=${btoa(Id)}`
        );
      } else if (this.ReceiptSettings.receipt_type == 3) {
        window.open(
          `https://${window.location.host}/receipts/salesreceiptv3.php?id=${btoa(Id)}`
        );
      } else {
        window.open(
          `https://${window.location.host}/receipts/salesreceipt.php?id=${btoa(Id)}`
        );
      }
    },
    ShowdispatchItem(data) {
      this.data.saledetail_id = data.id;
      this.data.product_id = data.product_id;
      this.data.product_name = data.product;
      this.data.quantity_remaining = data.qty_remaining;
    },
    ShowdispatchOrder(id) {
      this.orderdata.id = id;
    },
    resetDispatchItem() {
      this.data.saledetail_id = '';
      this.data.product_id = '';
      this.data.product_name = '';
      this.data.quantity = '';
      this.data.date = moment(new Date()).format("YYYY-MM-DD");
      this.modal_id = "";
    },
    resetDispatchOrder() {
      this.orderdata.id = '';
    },
    OrderDispatch(modalId) {
      this.modal_id = modalId;
      this.DispatchOrder(this.orderdata);
    },

    ItemDispatch(modalId) {
      this.modal_id = modalId;
      this.checkQuantity();
      if (this.QtyError != "") {
        return;
      } else {
        this.DispatchItem(this.data);
      }
    },

    checkQuantity() {
      if (this.data.quantity != '' && this.data.quantity > this.data.quantity_remaining) {
        this.QtyError = "Quantity is great than remaining quantity";
      } else {
        this.QtyError = "";
      }
    },

    FilterData() {
      this.FetchUntakenOrders(this.filterdata);
    },

    resetErrors() {
      this.QtyError = ""
    },

    Excel_export() {
      axios
        .post("export_untakenorders", this.filterdata, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "untaken_orders.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {
        });
    },
  },
  updated() {
    let total_amount = 0;
    let total_paid = 0;
    let total_discount = 0;
    let total_balance = 0;
    if (this.UntakenOrders) {
      this.UntakenOrders.forEach((item) => {
        total_amount = total_amount + parseInt(item.totalAmt);
        total_paid = total_paid + parseInt(item.totalPaid);
        total_discount = total_discount + parseInt(item.discount);
        total_balance = total_balance + parseInt(item.balance);
      });
      this.total_amount = total_amount;
      this.total_paid = total_paid;
      this.total_discount = total_discount;
      this.total_balance = total_balance;
    }
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          this.resetErrors();
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  created() {
    this.FetchProducts();
    this.FetchUntakenOrders(this.filterdata);
    this.FetchGeneralSettings();
    this.fetchReceiptSettings();
    this.FetchCustomers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center">Untaken Orders</h3>
              </div>
              <div class="col-md-4 mb-3">
                <label>FILTER BY BRANCHES</label>
                <model-list-select :list="Branches ? [{ id: 0, name: 'All Branches' }, ...Branches] : []" v-model="filterdata.branch_id" option-value="id"
                  option-text="name" placeholder="Select Branch" @input="FilterData()">
                </model-list-select>
              </div>
            </div>
            <div class="row mb-5">
              <div class="col-md-2 mt-4">
                <b-button variant="info" @click="Excel_export()"><i class="fa fa-file-excel"></i>Export</b-button>
              </div>
              <div class="col-md-4 form-group">
                <label>Customers</label>
                <model-list-select :list="Customers ? Customers : []" v-model="filterdata.customer" option-value="id"
                  option-text="name" placeholder="Select Customer" @input="FilterData()">
                </model-list-select>
              </div>
              <div class="col-md-4 form-group">
                <label>PRODUCT</label>

                <model-list-select :list="Products ? Products : []" v-model="filterdata.product" option-value="id"
                  option-text="name" placeholder="Select Product" @input="FilterData()">
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <b-button variant="warning" @click="FilterData()"><i class="fa fa-filter"></i> Filter
                  <b-spinner v-if="filterStatus" variant="light" small label="Spinning"></b-spinner>
                </b-button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                      :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table class="datatables" :items="UntakenOrders ? UntakenOrders : []" :fields="fields" responsive="sm"
                :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc" :filter="filter"
                :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(totalAmt)="data">
                  {{ thousandSeperator(data.item.totalAmt) }}
                </template>
                <template #cell(totalPaid)="data">
                  {{ thousandSeperator(data.item.totalPaid) }}
                </template>
                <template #cell(actions)="data">
                  <b-button variant="info" class="btn btn-sm" v-b-modal.dispatch-order-modal
                    @click="ShowdispatchOrder(data.item.id)">Dispatch</b-button>
                </template>
                <template #cell(details)="data">
                  <table class="table">
                    <thead v-if="data.index == 0">
                      <tr>
                        <th width="50%">Item</th>
                        <th width="10%">Qty</th>
                        <th width="10%">Qty Remaining</th>
                        <th width="10%">Action</th>
                      </tr>
                    </thead>
                    <thead v-else></thead>
                    <tbody>
                      <tr v-for="(sale, s) in data.item.items" :key="s">
                        <td width="50%">{{ sale.product }}</td>
                        <td width="10%">{{ sale.qty }} {{ sale.usymbol }}</td>
                        <td width="10%">{{ sale.qty_remaining }} {{ sale.usymbol }}</td>
                        <td>
                          <b-button class="btn btn-sm" v-b-modal.dispatch-item-modal @click="ShowdispatchItem(sale)"
                            variant="primary" v-if="branchid != 0">Dispatch</b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </template>
              </b-table>
              <!-- modal starts -->
              <b-modal id="dispatch-item-modal" hide-footer @hidden="resetDispatchItem">
                <template #modal-title> Dispatch {{ data.quantity }} {{ data.product_name }} </template>
                <div class="form-group mb-3">
                  <label>Quantity</label>
                  <div class="input-group">
                    <input type="number" placeholder="Enter quantity" class="form-control" v-model="data.quantity"
                      @input="checkQuantity()" />
                  </div>
                  <div class="text-danger" v-if="QtyError">
                    <em>{{ QtyError }}</em>
                  </div>
                </div>
                <div class="form-group mb-3">
                  <label>Dispatch Date</label>
                  <div class="input-group">
                    <input type="date" placeholder="Enter Date" class="form-control" v-model="data.date" />
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" data-dismiss="modal"
                    @click="closeModal('dispatch-item-modal')">
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button v-if="SaveStatus" type="button" disabled class="btn btn-primary"> <i class="fa fa-check"></i>
                    Submit
                    <b-spinner variant="light" small label="Spinning"></b-spinner>
                  </button>
                  <button v-else type="button" class="btn btn-primary" @click="ItemDispatch('dispatch-item-modal')"> <i
                      class="fa fa-check"></i>
                    Submit
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->

              <!-- dispatch order modal starts -->
              <b-modal header-bg-variant="warning" header-text-variant="light" body-text-variant="warning"
                footer-bg-variant="warning" footer-text-variant="warning" id="dispatch-order-modal" hide-footer
                @hidden="resetDispatchOrder">
                <template #modal-title> Dispatch this Order</template>
                <div class="form-group mb-2">
                  <div class="input-group">
                    <h5>
                      You are dispatching this order! Click Proceed Button to complete the process.
                    </h5>
                  </div>
                </div>
                <div class="form-group mb-3">
                  <label>Dispatch Date</label>
                  <div class="input-group">
                    <input type="date" placeholder="Enter Date" class="form-control" v-model="orderdata.date" />
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal"
                    @click="closeModal('dispatch-order-modal')">
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button type="button" class="btn btn-primary" @click="OrderDispatch('dispatch-order-modal')">
                    <i class="fa fa-edit"></i> Proceed
                    <b-spinner v-if="SaveStatus" variant="light" small label="Dispatching"></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- dispatch order modal ends -->
              <div class="row">
                <div class="col-md-3">
                  <h5>Total Amount: <span class="text-danger">{{ thousandSeperator(total_amount) }}</span></h5>
                </div>
                <div class="col-md-3">
                  <h5>Total Paid: <span class="text-danger">{{ thousandSeperator(total_paid) }}</span></h5>
                </div>
                <div class="col-md-3">
                  <h5>Total Discount: <span class="text-danger">{{ thousandSeperator(total_discount) }}</span></h5>
                </div>
                <div class="col-md-3">
                  <h5>Total Balance: <span class="text-danger">{{ thousandSeperator(total_balance) }}</span></h5>
                </div>
              </div>
            </div>
            <Loader v-if="!UntakenOrders" />
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}
</style>
